module.exports = __webpack_public_path__ + "img/dashboard.d4c9b873.png";